const customContactNumberStyles = {
  textField: { "& .MuiInputBase-input": { padding: "13px 13px" } },
} as const;

export default customContactNumberStyles;
